import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import SalesData from "./SalesData";
import TokenPrice from "./TokenPrice";
const FanTokenTabs = () => {
  const [key, setKey] = useState("price");

  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="mb-3 tab-btn-group"
      // className="tab-btn-group"
    >
      <Tab
        eventKey="price"
        title="Token Price"
        tabClassName="tab-btn"
        // className={"active"}
      >
        <TokenPrice />
      </Tab>
      <Tab
        eventKey="sales"
        title="Sales Data"
        tabClassName="tab-btn"
        // className={"active"}
      >
        <SalesData />
      </Tab>
    </Tabs>
  );
};

export default FanTokenTabs;
